<template>
  <div class="popUpWrap dark">
    <section class="popup dark assessment">
      <div class="topArea">
        <div v-if="!isUpdate" class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ titleText }}</h5>
          <p v-html="descriptionText" />
        </div>
        <div class="boxArea">
          <ul class="slashList flex">
            <li>
              <a class="flex item-center" @click.stop="onClickInstall">
                                  <span class="ico flex f-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                      <path d="M2.5 11.5H11.5" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
                                      <path d="M6.99512 8.5L6.99512 2M6.99512 8.5L4.5 6M6.99512 8.5L9.5 6" stroke="white" stroke-width="1.6" stroke-linecap="round"/>
                                  </svg>
                                  </span>
                Proctive
              </a>
            </li>
          </ul>
        </div>
        <div class="btnArea">
          <button v-if="!isUpdate" @click.stop="onClickClose">{{t("common-ok")}}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from '#imports';
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { OSType, getOS } from "~~/package/utils/OSUtil";
import { convertToNextLine } from "~~/application/utils/StringUtil";
import { applicationContext } from "@@/package/application/applicationContext";

const { t } = useI18n();
const dialogStore = useDialogStore();
const config = { public: applicationContext.getConfig() };

const isUpdate = computed(() => dialogStore.options?.props?.isUpdate ?? false);

const osInfo = {
  [OSType.WINDOWS]: {
    downloadUrl: `/updates/${config.public.DESKTOP_APP_NAME} Setup ${config.public.DESKTOP_APP_VERSION}.exe`,
  },
  [OSType.MACOS]: {
    downloadUrl: `/updates/${config.public.DESKTOP_APP_NAME}-${config.public.DESKTOP_APP_VERSION}-universal.dmg`,
  },
  [OSType.LINUX]: {
    downloadUrl: `/updates/${config.public.DESKTOP_APP_NAME} ${config.public.DESKTOP_APP_VERSION}.AppImage`,
  }
};

const titleText = computed(() => {
  return isUpdate.value 
    ? t("skillCertify-update-proctoring-program-title")
    : t("skillCertify-install-proctoring-program-title");
});

const descriptionText = computed(() => {
  if (isUpdate.value) {
    return convertToNextLine(t("skillCertify-update-proctoring-program-description"));
  }
  return `${convertToNextLine(t("skillCertify-install-proctoring-program-description"))}<br/><span class="white">${t("skillCertify-install-proctoring-program-description-bold")}</span>`
})

const currentOSInfo = computed(() => {
  const currentOS = getOS();
  console.log(osInfo[OSType.MACOS])
  // UNKNOWN이거나 지원되지 않는 OS인 경우 Windows를 기본값으로 사용
  if (currentOS === OSType.UNKNOWN || !osInfo[currentOS]) {
    return osInfo[OSType.WINDOWS];
  }
  return osInfo[currentOS];
});

const onClickClose = () => {
  if (!isUpdate.value) {
    dialogStore.close();
  }
};

const onClickInstall = () => {
  window.open(currentOSInfo.value.downloadUrl, '_blank');
};

// 업데이트 팝업인 경우 ESC 키로 닫기 방지
const handleKeyDown = (event: KeyboardEvent) => {
  if (isUpdate.value && event.key === 'Escape') {
    event.preventDefault();
    event.stopPropagation();
  }
};

onMounted(() => {
  if (isUpdate.value) {
    window.addEventListener('keydown', handleKeyDown);
  }
});

onUnmounted(() => {
  if (isUpdate.value) {
    window.removeEventListener('keydown', handleKeyDown);
  }
});
</script>

